import React, { useCallback } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { InputLabeledContainer, TextInput, AutoComplete } from 'tennders-common/form/components'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'
import useCompanies from 'tennders-company/list/hooks/useCompanies'

const CarrierCompanyInfo = (props) => {
  const { t } = useTranslation()
  const {
    form,
    errors,
    onChange,
    setform,
    onChangeMultiple,
    disabled = false
  } = props

  const { fetchCompany } = useCompanies()

  const selectCompany = useCallback(async (companyId) => {
    const response = await fetchCompany(companyId)
    if (response) {
      onChangeMultiple({
        companyName: response.name,
        companyAddress: response.address,
        companyNif: response.nif,
        companyContact: response.pointOfContact?.name,
        companyEmail: response.pointOfContact?.email
      })
    }
  }, [])
  return (
    <>
      <InputLabeledContainer
        name="companyName"
        label={t('document:companyName')}
        className="mb-24"
        form={form}
        disabled={disabled}
        errors={errors}
        onChange={(k, v) => {
          if (v?.id) {
            selectCompany(v?.id)
          } else {
            setform({
              ...form,
              companyName: '',
              companyAddress: '',
              companyNif: '',
              companyContact: '',
              companyEmail: ''
            })
          }
        }}
        renderInput={(rest) => (
          <AutoComplete
            url="companies/filter"
            className="form-input"
            autocomplete="new-password"
            placeholder={t('mandatoryFields:company_search_placeholder')}
            {...rest}
          />
        )}
      />
      <div className="d-flex">
        <InputLabeledContainer
          name="companyContact"
          label={t('document:contactName')}
          className="mb-24 mr-16"
          form={form}
          errors={errors}
          onChange={onChange}
          required
          disabled={disabled}
          renderInput={(rest) => (
            <TextInput
              placeholder={t('searchFilters:fullName')}
              maxLength={INPUT_CHARACTER_LIMITS.USER_NAME}
              {...rest}
            />
          )}
        />
        <InputLabeledContainer
          name="companyEmail"
          label={t('document:email')}
          className="mb-24"
          form={form}
          errors={errors}
          onChange={onChange}
          required
          disabled={disabled}
          renderInput={(rest) => (
            <TextInput
              placeholder={t('addBranch:email_placeholder')}
              maxLength={INPUT_CHARACTER_LIMITS.EMAIL}
              {...rest}
            />
          )}
        />
      </div>
    </>
  )
}

export default React.memo(CarrierCompanyInfo)
